<template>
    <div class="container my-3">
        <dl class="row">
            <dt class="col-lg-8 col-md-7 col-sm-5 col-12">
                <h3 class="text-dark-green nav-settings-head">Shop vs Shop+</h3>
            </dt>
            <dd class="col-lg-4 col-md-5 col-sm-7 col-12">
                <div class="row">
                    <div class="col-5">
                        <router-link :to="{ name: 'selling' }" class="btn btn-light btn-sm bg-white form-control">Go Back</router-link>
                    </div>
                    <div class="col-7">
                        <router-link :to="{ name: 'create-shop' }" class="loadn btn btn-dark-green btn-sm form-control">Upgrade to Shop+</router-link>
                    </div>
                </div>
            </dd>
        </dl>
        <p class="text-danger font-italic d-md-none">scroll table right to left to see all features</p>
        <div class="table-responsive">
            <table class="table">
                <thead class="thead-light">
                    <tr>
                        <th scope="col">Features</th>
                        <th scope="col">Basic Shop</th>
                        <th scope="col">Shop+</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="bg-light">Number of posts allowed</td>
                        <td>{{postsLimit}} Items</td>
                        <td>Unlimited Items</td>
                    </tr>
                    <tr>
                        <td class="bg-light">Promote items</td>
                        <td><i class="fas fa-check"></i></td>
                        <td><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="bg-light">Sell and buy items</td>
                        <td><i class="fas fa-check"></i></td>
                        <td><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="bg-light">Display business name</td>
                        <td><i class="fas fa-times"></i></td>
                        <td><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="bg-light">Secured shop manager</td>
                        <td><i class="fas fa-times"></i></td>
                        <td><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="bg-light">Sales performance chart</td>
                        <td><i class="fas fa-times"></i></td>
                        <td><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="bg-light">Number of item views</td>
                        <td><i class="fas fa-times"></i></td>
                        <td><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="bg-light">Overall item statistics</td>
                        <td><i class="fas fa-times"></i></td>
                        <td><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="bg-light">Sales revenue tracker</td>
                        <td><i class="fas fa-times"></i></td>
                        <td><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="bg-light">Apply discounts on items</td>
                        <td><i class="fas fa-times"></i></td>
                        <td><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="bg-light">Activity tracker</td>
                        <td><i class="fas fa-check"></i></td>
                        <td><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="bg-light">Customers logbook</td>
                        <td><i class="fas fa-times"></i></td>
                        <td><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="bg-light">Donate items</td>
                        <td><i class="fas fa-check"></i></td>
                        <td><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="bg-light">Donations record</td>
                        <td><i class="fas fa-times"></i></td>
                        <td><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="bg-light">Price</td>
                        <td>FREE</td>
                        <td>
                            <span v-if="theShopRent" class="text-uppercase">
                                {{theShopRent.currency}} {{theShopRent.price | money}}
                            </span>
                            <span v-else>TBA</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="bg-light">Payment cycle</td>
                        <td>None</td>
                        <td>Monthly</td>
                    </tr>
                    <tr>
                        <td scope="row" class="bg-light">Enjoy shop+ free for 14 days if you upgrade today</td>
                        <td><span class="btn btn-light"><i class="far fa-meh"></i> I'm your current shop</span></td>
                        <td>
                            <router-link :to="{ name: 'create-shop' }" class="btn btn-dark-green">
                                <i class="far fa-grin-alt"></i> Upgrade to Shop+
                            </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import LayoutUser from '@/layouts/User.vue'

export default {
    name: "SellerPlans",
    data() {
        return {
            postsLimit: process.env.VUE_APP_BSC_POST_LIMIT,
        }
    },
    methods: {
        ...mapActions(['fetchShopRent'])
    },
    computed: {
        ...mapGetters(['shopRent']),
        theShopRent() {
            if(this.shopRent && this.shopRent !== null){
                return this.shopRent
            }
            return false
        }
    },
    created() {
        this.fetchShopRent().then(() => {}).catch((e) => {})
        this.$emit('update:layout', LayoutUser);
    }
}
</script>